import { Skeleton } from "../Skeleton";

export const ContentSkeleton = () => {
  return (
    <div className="min-h-[calc(100vh-80px)] w-full p-[25px]">
      <div className="space-y-4">
        {/* Page Title */}
        <div className="space-y-2">
          <Skeleton className="h-8 w-48" />
          <Skeleton className="h-4 w-32" />
        </div>

        {/* Content Cards/Table */}
        <div className="space-y-3">
          {/* eslint-disable react/no-array-index-key */}
          {Array.from({ length: 5 }).map((_, index) => (
            <Skeleton
              key={`content-skeleton-${index}`}
              className="h-16 w-full"
            />
          ))}
          {/* eslint-enable react/no-array-index-key */}
        </div>
      </div>
    </div>
  );
};
